const SAMPLE_CONTEXT = {
  recipient_name: "Olivia",
  recipient_email: "olivia@example.com",
  profile_type: "business",
  account_email: "owner@example.com",
  login_url: "https://614shoplocal.com/login",
  site_url: "https://614shoplocal.com",
  business_name: "Green Cafe",
  business_email: "hello@greencafe.com",
  market_name: "Neighborhood Market",
  market_email: "hello@market.com",
  list_name: "Businesses",
  event_title: "Community Pop-up",
  submitted_by: "Green Cafe",
  submitted_by_email: "hello@greencafe.com",
  event_date: "August 12, 2026",
  event_time: "10:00 AM",
  event_location: "Columbus, OH",
  location: "Columbus",
  address: "123 Main Street",
};

export const renderTemplateString = (value = "", context = SAMPLE_CONTEXT) => (
  Object.entries(context).reduce((rendered, [key, replacement]) => (
    rendered
      .replaceAll(`{{${key}}}`, String(replacement || ""))
      .replaceAll(`{{ ${key} }}`, String(replacement || ""))
  ), value || "")
);

const MARKETING_FOOTER_HTML = `
  <div style="border-top: 1px solid #E2E8F0; margin-top: 28px; padding-top: 18px; color: #94A3B8; font-size: 12px; line-height: 1.6; text-align: center;">
    <p style="margin: 0 0 10px;">614 Shop Local<br />7385 North State Route 3 #1052<br />Westerville, OH 43082</p>
    <p style="margin: 0;"><a href="#" style="color: #64748B; text-decoration: underline;">Unsubscribe</a></p>
  </div>
`;
const BRAND_HEADER_HTML = `
  <div style="background: #000000; border-radius: 18px; padding: 28px 24px; text-align: center; margin: 0 0 28px;">
    <div style="font-family: 'Outfit', Arial, sans-serif; color: #FFFFFF; font-size: 34px; font-weight: 900; line-height: 1.15; letter-spacing: 0.02em;">
      <div>614</div>
      <div>SHOP</div>
      <div>LOCAL</div>
    </div>
  </div>
`;
const normalizeSystemEmailButtons = (html = "") => (
  (html || "")
    .replace(/background\s*:\s*#42D78A\s*;/gi, "background: #1a1a1a;")
    .replace(/color\s*:\s*#1a1a1a\s*;/gi, "color: #ffffff;")
);

export const renderEmailPreviewHtml = ({
  subject = "",
  heading = "",
  bodyHtml = "",
  includeMarketingFooter = false,
  includeAutomatedFooter = true,
}) => {
  const renderedSubject = renderTemplateString(subject);
  const renderedHeading = renderTemplateString(heading || subject);
  const renderedBody = normalizeSystemEmailButtons(renderTemplateString(bodyHtml));

  return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${renderedSubject || "Email preview"}</title>
    <style>
      * { box-sizing: border-box; }
      img, video { max-width: 100% !important; height: auto !important; }
      img { display: block; }
    </style>
  </head>
  <body style="font-family: 'Montserrat', Arial, sans-serif; background-color: #F8FAFC; padding: 40px; margin: 0;">
    <div style="max-width: 500px; margin: 0 auto; background: white; border-radius: 16px; padding: 40px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
      ${BRAND_HEADER_HTML}
      <h1 style="font-family: 'Outfit', Arial, sans-serif; color: #1a1a1a; font-size: 22px; margin-bottom: 16px;">${renderedHeading}</h1>
      ${renderedBody}
      ${includeMarketingFooter ? MARKETING_FOOTER_HTML : ""}
      ${includeAutomatedFooter ? `
        <hr style="border: none; border-top: 1px solid #E2E8F0; margin: 24px 0;" />
        <p style="color: #94A3B8; font-size: 12px;">This is an automated message from 614 Shop Local.</p>
      ` : ""}
    </div>
  </body>
</html>`;
};
